import type { IconData } from '@stacksjs/iconify-core'

export const ie4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#009A49\" d=\"M0 0h213.3v480H0z\"/><path fill=\"#FF7900\" d=\"M426.7 0H640v480H426.7z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ie4x3
